import { defineChain } from 'viem';

// Ethereum Mainnet
export const ethereumMainnet = {
  id: 1,
  name: 'Ethereum',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://eth.llamarpc.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Etherscan',
      url: 'https://etherscan.io',
    },
  },
} as const;

// Arbitrum One
export const arbitrumOne = {
  id: 42161,
  name: 'Arbitrum One',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://arb1.arbitrum.io/rpc'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Arbiscan',
      url: 'https://arbiscan.io',
    },
  },
} as const;

// ApeChain (Mainnet)
export const apeChain = {
  id: 33139,
  name: 'ApeChain',
  nativeCurrency: { name: 'ApeCoin', symbol: 'APE', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://apechain.calderachain.xyz/http'],
    },
  },
  blockExplorers: {
    default: {
      name: 'ApeChain Explorer',
      url: 'https://explorer.apechain.caldera.xyz',
    },
  },
} as const;

// Export all supported chains
export const supportedChains = [ethereumMainnet, arbitrumOne, apeChain];

// Token addresses per chain
export const TOKEN_ADDRESSES: Record<number, {
  USDC: string;
  APECOIN: string;
}> = {
  1: { // Ethereum Mainnet
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    APECOIN: '0x4d224452801ACEd8B2F0aebE155379bb5D594381'
  },
  42161: { // Arbitrum One
    USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    APECOIN: '0x4d224452801ACEd8B2F0aebE155379bb5D594381' // ApeCoin on Arbitrum
  },
  33139: { // ApeChain
    USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', // USDC on ApeChain (if exists, check)
    APECOIN: '0x4d224452801ACEd8B2F0aebE155379bb5D594381' // Native ApeCoin
  }
};

// Contract addresses per chain (set from environment variables or deployment)
export const CONTRACT_ADDRESSES: Record<number, string> = {
  1: '0xc6A80789E8ab72331A7BB44e7f006cD5Ff046b6a', // Ethereum Mainnet - redeployed with security features
  33139: '0x83079547fdCd8d2104913Db8d95FBD966F8754aA', // ApeChain - redeployed with security features
  42161: '0x7EfFADB6C485f22E7B9C2CA3D9eC1ef848ad3dec', // Arbitrum One - redeployed with security features
};
